export default __webpack_public_path__ + "static/media/047-ticket.4273a60a.svg";